module.exports = __webpack_public_path__ + "static/about_simulator_cactus_art-2262a7903da21b877d40d3f1379c0e86.png";